module.exports = __webpack_public_path__ + "static/media/newletter-img.7e346d51.png";